module.exports = __webpack_public_path__ + "img/blue_technical-3p_fQIq.svg";